<section *ngIf="!singleErrorView" class="section-separator no-margin padding-top-20"></section>
<section class="row padding-10">
	<p *ngIf="!singleErrorView" class="text-16">
		<icon class="color-red" type="exclamation-circle"></icon>
		<span class="icon-caption text-bold padding-left-10" dcrHTMLKey="SECURITIES_REPLACE_TITLE">The following securities cannot be analyzed.</span>
	</p>
	<p class="text-14 security-list margin-top-20 padding-top-10 padding-bottom-10">
		<span class="text-align-left"> {{ unsupportedSecurities.join(', ') }}</span>
	</p>
</section>
